var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "div",
        {
          staticClass: "modal-mask",
          on: {
            click: function($event) {
              return _vm.outsideClick()
            }
          }
        },
        [
          _c(
            "Box",
            {
              staticClass: "modal-wrapper",
              class: { absolute: _vm.absolutePos },
              style: {
                width: _vm.width,
                height: _vm.height,
                bottom: _vm.bottom,
                right: _vm.right,
                top: _vm.top
              }
            },
            [
              !_vm.showCloseText
                ? _c(
                    "span",
                    {
                      staticClass: "close-icon",
                      on: {
                        click: function($event) {
                          return _vm.closeClick()
                        }
                      }
                    },
                    [_c("Icon", { attrs: { name: "times" } })],
                    1
                  )
                : _c(
                    "span",
                    {
                      staticClass: "close-icon close-icon--alt",
                      on: {
                        click: function($event) {
                          return _vm.closeClick()
                        }
                      }
                    },
                    [
                      _c("Icon", { attrs: { name: "times" } }),
                      _c("span", [_vm._v(" Close")])
                    ],
                    1
                  ),
              _c(
                "Box",
                {
                  staticClass: "modal-container",
                  style: { height: _vm.height },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm.withScroll
                    ? _c(
                        "ScrollablePanel",
                        { style: { height: _vm.height } },
                        [
                          _vm._t("default", null, {
                            requestClose: _vm.requestClose
                          })
                        ],
                        2
                      )
                    : _vm._t("default", null, {
                        requestClose: _vm.requestClose
                      })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }